import React from 'react';
import { ClockIcon, CalendarIcon, MousePointerClickIcon, DownloadIcon, ToggleRightIcon, SmartphoneIcon, MapPinIcon, TimerIcon } from 'lucide-react';
export const KpiRow = () => {
  return <div className="mb-6" data-id="element-232">
      {/* First row of KPIs */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4" data-id="element-233">
        {/* Card 1: Senest set */}
        <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-234">
          <div className="text-sm text-gray-500 mb-1 flex items-center gap-1" data-id="element-235">
            <CalendarIcon size={14} className="flex-shrink-0" data-id="element-236" />
            <span className="truncate" data-id="element-237">Senest set</span>
          </div>
          <div className="font-medium truncate" data-id="element-238">I dag, 10:42</div>
          <div className="text-xs text-gray-500 mt-1 flex items-center gap-1" data-id="element-239">
            <MapPinIcon size={12} className="flex-shrink-0" data-id="element-240" />
            <span className="truncate" data-id="element-241">København</span>
            <SmartphoneIcon size={12} className="ml-1 flex-shrink-0" data-id="element-242" />
            <span className="truncate" data-id="element-243">Desktop</span>
          </div>
        </div>
        {/* Card 2: Antal besøg */}
        <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-244">
          <div className="text-sm text-gray-500 mb-1 truncate" data-id="element-245">
            Antal besøg (sessions)
          </div>
          <div className="font-medium text-xl" data-id="element-246">5</div>
          <div className="text-xs text-gray-500 mt-1 truncate" data-id="element-247">
            Seneste: I dag, 10:42
          </div>
        </div>
        {/* Card 3: Samlet tid */}
        <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-248">
          <div className="text-sm text-gray-500 mb-1 flex items-center gap-1" data-id="element-249">
            <ClockIcon size={14} className="flex-shrink-0" data-id="element-250" />
            <span className="truncate" data-id="element-251">Samlet tid på tilbuddet</span>
          </div>
          <div className="font-medium text-xl" data-id="element-252">18:23</div>
          <div className="text-xs text-gray-500 mt-1 truncate" data-id="element-253">
            Fordelt over 5 sessions
          </div>
        </div>
      </div>
      {/* Second row of KPIs */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-254">
        {/* Card 4: Gns. tid pr. side */}
        <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-255">
          <div className="text-sm text-gray-500 mb-1 flex items-center gap-1" data-id="element-256">
            <TimerIcon size={14} className="flex-shrink-0" data-id="element-257" />
            <span className="truncate" data-id="element-258">Gns. tid pr. side</span>
          </div>
          <div className="font-medium text-xl" data-id="element-259">02:41</div>
          <div className="text-xs text-gray-500 mt-1 truncate" data-id="element-260">
            Median: 01:56
          </div>
        </div>
        {/* Card 5: Klik på scenarier */}
        <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-261">
          <div className="text-sm text-gray-500 mb-1 flex items-center gap-1" data-id="element-262">
            <MousePointerClickIcon size={14} className="flex-shrink-0" data-id="element-263" />
            <span className="truncate" data-id="element-264">Klik på scenarier</span>
          </div>
          <div className="flex items-center gap-2 mt-2 justify-center" data-id="element-265">
            <div className="flex flex-col items-center" data-id="element-266">
              <div className="h-12 w-4 bg-gray-200 rounded-sm relative" data-id="element-267">
                <div className="absolute bottom-0 w-full bg-blue-200 h-6 rounded-sm" data-id="element-268"></div>
              </div>
              <span className="text-xs mt-1" data-id="element-269">Good</span>
              <span className="text-xs font-medium" data-id="element-270">12</span>
            </div>
            <div className="flex flex-col items-center" data-id="element-271">
              <div className="h-12 w-4 bg-gray-200 rounded-sm relative" data-id="element-272">
                <div className="absolute bottom-0 w-full bg-blue-300 h-10 rounded-sm" data-id="element-273"></div>
              </div>
              <span className="text-xs mt-1" data-id="element-274">Better</span>
              <span className="text-xs font-medium" data-id="element-275">21</span>
            </div>
            <div className="flex flex-col items-center" data-id="element-276">
              <div className="h-12 w-4 bg-gray-200 rounded-sm relative" data-id="element-277">
                <div className="absolute bottom-0 w-full bg-blue-400 h-4 rounded-sm" data-id="element-278"></div>
              </div>
              <span className="text-xs mt-1" data-id="element-279">Best</span>
              <span className="text-xs font-medium" data-id="element-280">8</span>
            </div>
          </div>
        </div>
        {/* Card 6: Handlinger */}
        <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-281">
          <div className="text-sm text-gray-500 mb-1 truncate" data-id="element-282">Handlinger</div>
          <div className="text-xs mt-2" data-id="element-283">
            <div className="flex items-center gap-1 mb-1" data-id="element-284">
              <DownloadIcon size={12} className="flex-shrink-0" data-id="element-285" />
              <span className="truncate" data-id="element-286">Downloads: 3</span>
            </div>
            <div className="flex items-center gap-1 mb-1" data-id="element-287">
              <ToggleRightIcon size={12} className="flex-shrink-0" data-id="element-288" />
              <span className="truncate" data-id="element-289">Tilvalg åbnet: 5</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-290">
              <span className="w-2 h-2 rounded-full bg-yellow-500 flex-shrink-0" data-id="element-291"></span>
              <span className="truncate" data-id="element-292">Accept: Ikke påbegyndt</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
};